import React from 'react';
import { Reveal } from './ui/Reveal';
import { benefits } from '../data/content';
export function BenefitsSection() {
  return <section aria-labelledby="beneficios" className="bg-navy" data-id="element-16" data-mp="axhve37bl2g">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-17" data-mp="3iqq4lj6hcat7">
        <h2 id="beneficios" className="font-display text-[1.6rem] font-extrabold uppercase leading-[1.08] tracking-tight text-white sm:text-4xl" data-id="element-18" data-mp="3iodn174mw2go">
          ¿Qué puede cambiar cuando{' '}
          <span className="text-sol" data-id="element-19" data-mp="3dqvg1ma6fxbb">empezás?</span>
        </h2>
        <p className="mx-auto mt-1 max-w-xl text-sm leading-snug text-white/90" data-id="element-20" data-mp="3dp0rlxzp5n2h">
          Aprender inglés práctico puede transformar la manera en que vivís tus
          viajes.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-21" data-mp="34qp5o99rzdgd">
          {benefits.map((benefit, i) => <Reveal key={benefit.title} as="li" delay={i * 0.03} className="h-full rounded-xl border-2 border-sol bg-white p-2.5 text-left" data-id="element-22" data-mp="y0qxtd1687s6" data-mpi={i}>
              <h3 className="font-sub text-sm font-bold leading-tight text-navy" data-id="element-23" data-mp="2bd2wpioxykly">
                <span className="text-coral" aria-hidden="true" data-id="element-24" data-mp="27dbzaw4wt68g">✓ </span>
                {benefit.title}
              </h3>
              <p className="mt-0.5 text-xs leading-snug text-navy/80 sm:text-sm" data-id="element-25" data-mp="2l6ti2epruexf">
                {benefit.desc}
              </p>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}